const page = document.querySelector('[data-register-page]');
if (page) {
  const form = page.querySelector('[data-register-form]');
  const username = page.querySelector('[data-register-username]');
  const usernameStatus = page.querySelector('[data-username-status]');
  const password = page.querySelector('[data-register-password]');
  const strength = page.querySelector('[data-password-strength]');
  let usernameTimer = 0;
  let usernameAvailable = false;

  username?.addEventListener('input', () => {
    username.value = normalizeUsername(username.value);
    usernameAvailable = false;
    usernameStatus.textContent = 'در حال بررسی نام کاربری…';
    usernameStatus.className = '';
    clearTimeout(usernameTimer);
    usernameTimer = setTimeout(checkUsername, 350);
  });
  password?.addEventListener('input', updateStrength);
  page.addEventListener('click', event => {
    const toggle = event.target.closest('[data-toggle-password]');
    if (!toggle) return;
    const input = toggle.parentElement.querySelector('input');
    input.type = input.type === 'password' ? 'text' : 'password';
    const visible = input.type === 'text';
    toggle.classList.toggle('active', visible);
    toggle.querySelector('use')?.setAttribute('href', visible ? '#ui-eye-off' : '#ui-eye');
    toggle.setAttribute('aria-pressed', String(visible));
    toggle.setAttribute('aria-label', visible ? 'پنهان‌کردن رمز' : 'نمایش رمز');
  });
  form?.addEventListener('submit', event => {
    const firstInvalid = [...form.elements].find(x => typeof x.checkValidity === 'function' && !x.checkValidity());
    if (firstInvalid || !usernameAvailable) {
      if (!usernameAvailable) { event.preventDefault(); username.focus(); usernameStatus.textContent = 'ابتدا یک نام کاربری آزاد و معتبر انتخاب کن.'; usernameStatus.className = 'error'; }
      else { event.preventDefault(); firstInvalid.reportValidity(); firstInvalid.focus(); }
    }
  });
  if (username?.value) checkUsername();
  updateStrength();

  async function checkUsername() {
    const value = normalizeUsername(username.value);
    if (value.length < 3) { usernameStatus.textContent = 'نام کاربری حداقل ۳ کاراکتر است.'; usernameStatus.className = 'error'; return; }
    try {
      const url = new URL(page.dataset.usernameCheckUrl, location.origin); url.searchParams.set('userName', value);
      const response = await fetch(url, { credentials: 'same-origin' }); const result = await response.json();
      usernameAvailable = Boolean(result.available);
      usernameStatus.textContent = result.message;
      usernameStatus.className = usernameAvailable ? 'success' : 'error';
      if (result.normalized) username.value = result.normalized;
    } catch { usernameStatus.textContent = 'بررسی خودکار انجام نشد؛ فرم هنگام ثبت دوباره کنترل می‌شود.'; usernameStatus.className = 'warning'; usernameAvailable = true; }
  }
  function updateStrength() {
    const value = password?.value || '';
    let score = 0; if (value.length >= 8) score++; if (/[a-z]/.test(value)) score++; if (/\d/.test(value)) score++; if (/[^a-z0-9]/i.test(value) || value.length >= 12) score++;
    strength?.querySelectorAll('span').forEach((bar, index) => bar.classList.toggle('active', index < score));
  }
  function normalizeUsername(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 24); }
}
